import { Star } from "lucide-react";

const links = [
  { label: "Create Portrait", path: "/create" },
  { label: "Background", path: "/background" },
  { label: "Outfit Change", path: "/outfit" },
  { label: "Pricing", path: "/pricing" },
  { label: "Gallery", path: "/gallery" },
];

export const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-[#0a0a0c]">
      <div className="max-w-6xl mx-auto px-6 py-10">
        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8 mb-8">
          {/* Brand */}
          <div className="max-w-xs">
            <button onClick={() => onNavigate("/")} className="flex items-center gap-2 mb-3">
              <Star className="w-5 h-5 text-[#D4AF37]" />
              <span className="font-serif text-xl tracking-tight text-white">StarFrame AI</span>
            </button>
            <p className="text-white/60 text-sm leading-relaxed">
              Premium AI portrait studio. Transform any photo into stunning professional portraits in seconds.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]/60 font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2.5">
              {links.map(l => (
                <li key={l.path}>
                  <button
                    onClick={() => onNavigate(l.path)}
                    className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]/60 font-semibold mb-3">Support</h4>
            <ul className="space-y-2.5">
              <li><a href="mailto:info@mitaict.com" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">Contact Us</a></li>
              <li><button onClick={() => onNavigate("/start")} className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">Get Started</button></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]/60 font-semibold mb-3">Legal</h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => onNavigate("/privacy")}
                  className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-privacy-link"
                >
                  Privacy Policy
                </button>
              </li>
              <li className="text-white/40 text-xs pt-1">GDPR · Swedish Law</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs">
            &copy; {year} StarFrame AI. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            A product of{" "}
            <a
              href="https://www.mitaict.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-[#D4AF37] transition-colors font-medium"
            >
              MITA ICT
            </a>
            {" "}— Full rights &amp; ownership.
          </p>
        </div>
      </div>
    </footer>
  );
};
